// extracted by mini-css-extract-plugin
export default {"products":"allProducts_products__+2vkp","left":"allProducts_left__ji0bM","right":"allProducts_right__WDxwL"};